import { render, staticRenderFns } from "./RiskStandardInd.vue?vue&type=template&id=34f09dc8&scoped=true"
import script from "./RiskStandardInd.vue?vue&type=script&lang=js"
export * from "./RiskStandardInd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f09dc8",
  null
  
)

export default component.exports